<template>
  <div class="value-road-map-setup">
    <div class="d-flex">
      <h3 class="text-primary pt-3">Road Map <modal-link modal-id="Road Map" :content-list="$parent.pageContent"></modal-link></h3>
    </div>
    <div class="value-road-map-header">    
        <div>Drag and drop the functional or emotional needs to Focus Areas; Specify the Initiatives that connect to the Focus Areas.</div>
    </div>
    <div class="form-row">
            <div class = "value-road-other-area">
                <div class="d-flex justify-content-between">
                    <div>
                        <div class="d-flex">
                          <h4 class="text-primary mr-1">Other Areas</h4>
                          <modal-link modal-id="Other Areas" :content-list="$parent.pageContent"></modal-link>
                        </div>
                        <div class="description">Areas of value that are non-distinctive</div>
                    </div>
                    <div class="d-flex btn-group-horizontal align-items-center pl-2 pt-3">
                        <div>
                            <button type="submit" class="btn btn-primary float-right mr-2" :disabled="!previousEffortSet.enablePreviousButton" @click="switchToPrevious()">
                            <span>Undo</span>
                            </button>
                        </div>
                        <div>
                            <button type="submit" class="btn btn-primary float-right mr-2"  @click="getDataDrivenPicks()">
                                <span>Data-Driven Picks</span>
                            </button>
                        </div>
                    </div>
                </div>
                <VueDraggable
                    v-model="otherAreaEfforts"
                    :disabled="!enabled"
                    class="list-group draggable-container"
                    group="bucket"
                    ghost-class="draggable-ghost"
                    :move="checkMove"
                    :sort="true"
                    @start="dragging = true"
                    @end="endOfDragOtherAreaEfforts"
                    options="people"
                    >
                    <div class="list-group-item draggable-card" v-for="element in otherAreaEfforts" :key="element.name" :index="element.name">
                      <div>
                        <font-awesome-icon :icon="['fas', 'grip-vertical']" />
                        <span :class="element.needType + ' pl-1'">
                          {{ element.name }}
                            <div style="float: right;padding-bottom: 5px;">
                              <a href="#!" @click="displayInitiatives(element)"> 
                                  <img src="/img/icons/wratings-mini-logo.png" width="20" height="20"/>
                              </a>
                            </div>
                        </span>
                        <input
                            v-model="element.initiative"
                            :name="element.name"
                            :id="element.name"
                            placeholder="Initiative" 
                            type="text"
                            class="form-control custom-text shadow"
                            @blur="saveInitiative($event)"
                            style=""
                            />                              
                      </div>
                    </div>
            
                </VueDraggable>                
                
            </div>
            <div class = "value-road-map-area">
                <div class="d-flex">
                  <h4 class="text-primary mr-1">Focus Areas / Initiatives</h4>
                  <modal-link modal-id="Focus Areas" :content-list="$parent.pageContent"></modal-link>
                </div>
                <div class="description">Areas of value to emphasize / Programs to create and capture more value</div>
                <VueDraggable
                    v-model="focusAreaEfforts"
                    :disabled="!enabled"
                    class="list-group draggable-container"                   
                    group="bucket"
                    ghost-class="draggable-ghost"
                    :move="checkMove"
                    :sort="true"
                    @start="dragging = true"
                    @end="endOfDragFocusAreaEfforts"
                    options="people"
                    >
                    <div class="list-group-item draggable-card" v-for="element in focusAreaEfforts" :key="element.name" :index="element.name">
                        <span :class="element.needType + ' pl-1'"><i class="fa fa-caret-right" aria-hidden="true"></i>{{ element.name }}
                          <div style="float: right;padding-bottom: 5px;">
                            <a href="#!" @click="displayInitiatives(element)">
                              <img src="/img/icons/wratings-mini-logo.png" width="20" height="20"/>
                            </a>
                          </div>
                        </span>
                        <input
                        v-model="element.initiative"
                        placeholder="Initiative" 
                        type="text"
                        :name="element.name"
                        :id="element.name"
                        class="form-control custom-text shadow"
                        @blur="saveInitiative($event)"
                        style=""
                        />    
                    </div>
                </VueDraggable>    
                            
            </div>
    </div>  
    <road-map-initiatives ref="roadMapInitiatives" @add-initiative="handleAddInitiative" :showCustomInitiative="true"/>  
  </div>
  
</template>
<script>
//import WinnersService from "../../services/chart/winners.service";
import AdminService from "../../services/admin.service";
import ValueGroupMapService from "../../services/chart/value.group.map.service"
import RoadMapInitiatives from "../../modals/RoadMapInitiatives.vue";
import { VueDraggable } from 'vue-draggable-plus';
import $ from "jquery";
import ContentMixins from "../../mixins/ContentMixins.vue";

export default {
  name: "ValueRoadMapSetup",
  mixins: [ContentMixins],
  components: { VueDraggable,RoadMapInitiatives },  
    props: {
      inputSurveyGroupId: {
        type: String,
        default: ""
      },
      inputUseEqualWeight: {
        type: String,
        default: "N"
      },      
      inputPeriodId: {
        type: Number,
        default: 0
      },
    surveyCode: {
      type: String,
      default: ""
    },
    clientChartObject: {
      type: Object,
      default: function() {
        return {
          clientChartId: 0
        };
      }
    }
  },
  data() {
    return {
      valueRoadMapId: 0,
      enabled: true,
      currentIndex: 0,
      focusAreaEfforts: [],
      otherAreaEfforts: [],
      previousEffortSet: {
        name : "Previous", isPopulated: false, enablePreviousButton: false
      },
      defaultEffortSets: [
        {name: "Manual", focusAreaEfforts: [], otherAreaEfforts: [] },
      ]
    };
  },
  methods: {
    saveInitiative: function(event) {
     let needName = event.target.name;
      let element = this.focusAreaEfforts.find(x => x.name === needName) ||
                    this.otherAreaEfforts.find(x => x.name === needName);
      if (element) {
        element.initiative = event.target.value; // set the initiative in the element
        this.valueRoadMapId = 0; // reset the valueRoadMapId to 0 when a change happens
      }

    },
    handleAddInitiative(initiative,needName) {
      let element = this.focusAreaEfforts.find(x => x.name === needName) ||
                    this.otherAreaEfforts.find(x => x.name === needName);
      if (element) {
        element.initiative = initiative.initiative; // set the initiative in the element
        this.valueRoadMapId = 0; // reset the valueRoadMapId to 0 when a change happens
      }
    },
    displayInitiatives(element) {
      let needName = element.name;
      let moatName = element.moatName;
      let initiativeSuggestions = element.initiativeSuggestions;
      this.$refs.roadMapInitiatives.$data.title = needName;
      this.$refs.roadMapInitiatives.$data.moatName = moatName;
      this.$refs.roadMapInitiatives.$data.selectedInitiative = {
        initiative: element.initiative
      };
      this.$refs.roadMapInitiatives.$data.needName = needName;
      this.$refs.roadMapInitiatives.$data.initiatives = JSON.parse(JSON.stringify(initiativeSuggestions));
      this.$refs.roadMapInitiatives.$data.moatInitiatives = JSON.parse(JSON.stringify(element.moatInitiatives));
      this.$refs.roadMapInitiatives.$data.moatDescription = JSON.parse(JSON.stringify(element.moatDescription));
      this.$refs.roadMapInitiatives.loadData();
      this.$modal.show("road-map-initiatives");
    },
    getChartCardClass() {
      let returnClassName = "chart-card-row chart-card-name ";
      return returnClassName;
    },
    savePrevious: function(defaultTypeName){
      if (!this.previousEffortSet.isPopulated){
        this.previousEffortSet.focusAreaEfforts = this.focusAreaEfforts;
        this.previousEffortSet.otherAreaEfforts = this.otherAreaEfforts;
        this.previousEffortSet.isPopulated =  true;
      }
      if(this.previousEffortSet.isPopulated){
        this.previousEffortSet.enablePreviousButton = true;
      }
    },
    switchToPrevious: function(){
      if (!$.isEmptyObject(this.previousEffortSet)) {
        let focusAreaEfforts = JSON.parse(JSON.stringify(this.previousEffortSet.focusAreaEfforts));
        let otherAreaEfforts = JSON.parse(JSON.stringify(this.previousEffortSet.otherAreaEfforts));
        if (!this.isDefaultTypeEmpty(focusAreaEfforts,otherAreaEfforts)){
          this.setEffortSet(focusAreaEfforts,otherAreaEfforts);
          this.previousEffortSet.enablePreviousButton = false;
        }
      }
    },
    switchToDefault: function(defaultTypeName){
      let defaultEffortSet = this.defaultEffortSets.find(x => x.name == defaultTypeName)
      if (!$.isEmptyObject(defaultEffortSet)) {
        let focusAreaEfforts = JSON.parse(JSON.stringify(defaultEffortSet.focusAreaEfforts));
        let otherAreaEfforts = JSON.parse(JSON.stringify(defaultEffortSet.otherAreaEfforts));
        if (!this.isDefaultTypeEmpty(focusAreaEfforts,otherAreaEfforts)){
          this.savePrevious(defaultTypeName);
          this.setEffortSet(focusAreaEfforts,otherAreaEfforts);
        }
      }
    },    
    endOfDragOtherAreaEfforts: function(event) {
      this.valueRoadMapId = 0; // reset the valueRoadMapId to 0 when a change happens
    },
    endOfDragFocusAreaEfforts: function(event) {
      this.valueRoadMapId = 0; // reset the valueRoadMapId to 0 when a change happens
    },
    
    checkMove: function(e) {
    },
    setupValueGroupMapSetupForSave: function() {
      for (let focusAreaEffortsIndex = 0; focusAreaEffortsIndex < this.focusAreaEfforts.length; focusAreaEffortsIndex++) {
        this.focusAreaEfforts[focusAreaEffortsIndex].sequenceNumber = focusAreaEffortsIndex + 1;
      }
      for (let otherAreaEffortsIndex = 0; otherAreaEffortsIndex < this.otherAreaEfforts.length; otherAreaEffortsIndex++) {
        this.otherAreaEfforts[otherAreaEffortsIndex].sequenceNumber = otherAreaEffortsIndex + 1;
      }
    },
    saveWinnersMap: async function() {
      this.setupValueGroupMapSetupForSave();
      ValueGroupMapService.saveValueRoadMapSetup(this.surveyCode, this.focusAreaEfforts, this.otherAreaEfforts, this.valueRoadMapId,this.saveValueRoadMapSetupCallback, this) 
    },
    saveValueRoadMapSetupCallback: function(response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        AdminService.displayInfoMessage({ text: response.data.message });
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    loadData: function() {
      if (this.surveyCode != "" && this.inputPeriodId != 0) {
        ValueGroupMapService.getValueRoadMapSetupBySurveyCode(this.surveyCode,  this.clientChartId,this.inputPeriodId, this.inputSurveyGroupId, this.inputUseEqualWeight, this.loadDataCallback, this);
      }
    },
    getDataDrivenPicks: function() {
      if (this.surveyCode != "") {
        let competitors = [];
        for (let index = 0; index < this.$parent.$data.values.length; index++) {
          competitors.push(this.$parent.$data.values[index]);
        }
        let benchmarks = []
        for (let index = 0; index < this.$parent.$data.competitors.length; index++) {
          let competitor = this.$parent.$data.competitors[index];
          if (typeof competitor !== "undefined") {
            benchmarks.push(competitor);
          }
        }
        ValueGroupMapService.getDataDrivenPicks(this.valueRoadMapId, this.surveyCode, competitors, benchmarks,this.inputPeriodId, this.focusAreaEfforts,this.otherAreaEfforts,this.clientChartId,this.getDataDrivenPicksCallback, this);
      }
    },
    getDataDrivenPicksCallback: function(response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.defaultEffortSets = response.data.data.defaultEffortSets;
        this.valueRoadMapId = response.data.data.valueRoadMapId;
        this.$parent.buildUrlParams(this.clientChartObject.clientId);
        this.switchToDefault('Default')
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    loadDataCallback: function(response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        let focusAreaEfforts = response.data.data.focusAreaEfforts;
        let otherAreaEfforts = response.data.data.otherAreaEfforts;
        this.defaultEffortSets = response.data.data.defaultEffortSets;
        this.valueRoadMapId = response.data.data.valueRoadMapId;
        if (!this.isDefaultTypeEmpty(focusAreaEfforts,otherAreaEfforts)){
          this.focusAreaEfforts = focusAreaEfforts;
          this.otherAreaEfforts = otherAreaEfforts;
        } else {
          for (let index = 0; index < this.defaultEffortSets.length; index++) {
            let defaultSet = this.defaultEffortSets[index];
            if (!this.isDefaultTypeEmpty(defaultSet.focusAreaEfforts,defaultSet.otherAreaEfforts)){
              this.switchToDefault(defaultSet.name);
              break;
            }
          }
        }
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    isDefaultTypeEmpty: function(focusAreaEfforts, otherAreaEfforts){
      if (typeof focusAreaEfforts == "undefined" || typeof otherAreaEfforts == "undefined"){
        return true;
      }
      return focusAreaEfforts.length == 0 && otherAreaEfforts.length == 0 ;
    },
    setEffortSet: function(focusAreaEfforts, otherAreaEfforts){
      this.focusAreaEfforts = focusAreaEfforts;
      this.otherAreaEfforts = otherAreaEfforts;
    }    
  },
  created() {},
  mounted() {
    this.loadData();
  },
  watch: {
    clientChartId: function() {
      this.loadData();
    },
    surveyCode: function() {
      this.loadData();
    }
  },
  computed: {
    clientChartId: function() {
      return this.clientChartObject.clientChartId;
    }
  }
};
</script>
